<template>
  <div class="region_password_gate" v-if="show" ref="gateRoot">
    <img class="gate_bg" src="/static/images/giftBagProduct/bg@2x.png" alt="" />
    <div class="gate_scroll" ref="gateScroll">
      <img
        class="gate_title pos-r zi-1"
        :src="banner || '/static/images/giftBagProduct/tittle@2x.png'"
        alt=""
        @error="bannerErrorHandle"
      />
      <div class="gate_content">
        <div class="gate_time" v-if="timeText">活动时间：{{ timeText }}</div>
        <div class="gate_sub">内购专享 · 口令验证通道</div>

        <div class="gate_card">
          <div class="gate_card_hd">
            <i class="gate_bar"></i>
            <span class="f18 color-29 fw-b">请输入内购口令</span>
          </div>
          <div class="code_boxes">
            <input
              v-for="(item, index) in codes"
              :key="index"
              :ref="'codeInput' + index"
              class="code_box"
              type="tel"
              inputmode="numeric"
              maxlength="1"
              :value="codes[index]"
              @focus="focusIndex = index"
              @click="onBoxClick(index)"
              @input="onInput(index, $event)"
              @keydown.delete="onDelete(index, $event)"
            />
          </div>
          <div class="gate_tip">口令输入正确即可参与</div>
          <van-button
            class="gate_submit"
            round
            block
            color="linear-gradient( 90deg, #7F60DF 0%, #BD89FF 100%)"
            :loading="submitting"
            :disabled="word.length < 4"
            @click="submitHandle"
          >
            验证口令，进入内购
          </van-button>
        </div>

        <div class="gate_contact flex jc-sb w-100 pos-r zi-1">
          <div class="gate_contact_item_line left"></div>
          <div class="gate_contact_item"></div>
          <div class="gate_contact_item_line right"></div>
          <div class="gate_contact_item"></div>
        </div>

        <div class="gate_process">
          <div class="gate_card_hd">
            <i class="gate_bar"></i>
            <span class="f18 color-29 fw-b">参与流程</span>
          </div>
          <img class="gate_steps" src="/static/images/giftBagProduct/stepsimg@2x.png" alt="" />
        </div>

        <div class="gate_footer">最终解释权归可丽金官方所有</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'regionPasswordGateFromGroup',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    submitting: {
      type: Boolean,
      default: false
    },
    banner: {
      type: String,
      default: ''
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      codes: ['', '', '', ''],
      focusIndex: 0,
      _scrollTop: 0
    }
  },
  computed: {
    timeText() {
      if (!this.startTime && !this.endTime) return ''
      if (this.startTime && this.endTime) return this.startTime + '-' + this.endTime
      return this.startTime || this.endTime
    },
    word() {
      return this.codes.join('')
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (val) {
          this.lockPageScroll()
          this.codes = ['', '', '', '']
          this.focusIndex = 0
          this.$nextTick(() => {
            this.bindTouchLock()
            this.focusBox(0)
          })
        } else {
          this.unbindTouchLock()
          this.unlockPageScroll()
        }
      }
    }
  },
  beforeDestroy() {
    this.unbindTouchLock()
    this.unlockPageScroll()
  },
  methods: {
    lockPageScroll() {
      this._scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      document.body.style.overflow = 'hidden'
      document.body.style.position = 'fixed'
      document.body.style.top = '-' + this._scrollTop + 'px'
      document.body.style.left = '0'
      document.body.style.right = '0'
      document.documentElement.style.overflow = 'hidden'
    },
    unlockPageScroll() {
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.left = ''
      document.body.style.right = ''
      document.documentElement.style.overflow = ''
      if (this._scrollTop) {
        window.scrollTo(0, this._scrollTop)
        this._scrollTop = 0
      }
    },
    bindTouchLock() {
      this.unbindTouchLock()
      var root = this.$refs.gateRoot
      if (!root) return
      this._onTouchMove = (e) => {
        var scrollEl = this.$refs.gateScroll
        if (!scrollEl || !scrollEl.contains(e.target)) {
          e.preventDefault()
          return
        }
        if (scrollEl.scrollHeight <= scrollEl.clientHeight + 1) {
          e.preventDefault()
        }
      }
      root.addEventListener('touchmove', this._onTouchMove, { passive: false })
    },
    unbindTouchLock() {
      var root = this.$refs.gateRoot
      if (root && this._onTouchMove) {
        root.removeEventListener('touchmove', this._onTouchMove)
      }
      this._onTouchMove = null
    },
    bannerErrorHandle(e) {
      e.target.onerror = null
      e.target.src = '/static/images/giftBagProduct/tittle@2x.png'
    },
    getInputRef(index) {
      var ref = this.$refs['codeInput' + index]
      return Array.isArray(ref) ? ref[0] : ref
    },
    focusBox(index) {
      var el = this.getInputRef(index)
      if (el && el.focus) {
        el.focus()
        if (el.setSelectionRange && el.value) {
          el.setSelectionRange(0, el.value.length)
        }
      }
    },
    onBoxClick(index) {
      this.focusIndex = index
      this.focusBox(index)
    },
    onInput(index, e) {
      var raw = (e.target.value || '').replace(/\D/g, '')
      var digit = raw.slice(-1)
      this.$set(this.codes, index, digit)
      e.target.value = digit
      if (digit && index < 3) {
        this.focusIndex = index + 1
        this.$nextTick(() => {
          this.focusBox(index + 1)
        })
      }
    },
    onDelete(index, e) {
      if (this.codes[index]) {
        this.$set(this.codes, index, '')
        e.target.value = ''
        e.preventDefault()
        return
      }
      if (index > 0) {
        e.preventDefault()
        this.$set(this.codes, index - 1, '')
        this.focusIndex = index - 1
        this.$nextTick(() => {
          this.focusBox(index - 1)
        })
      }
    },
    submitHandle() {
      if (this.word.length < 4) {
        this.$toast('请输入完整口令')
        return
      }
      this.$emit('submit', {
        word: this.word
      })
    }
  }
}
</script>

<style scoped lang="scss">
.region_password_gate {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2002;
  overflow: hidden;
  overscroll-behavior: none;
  background: #7b5cff;
}
.gate_bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  pointer-events: none;
}
.gate_scroll {
  position: relative;
  z-index: 1;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}
.gate_content {
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  min-height: 100%;
  padding: 0 0.2rem 0.23rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.gate_title {
  display: block;
  width: 100%;
}
.gate_time {
  padding: 0.04rem 0.16rem;
  font-size: 0.12rem;
  color: #E97205;
  background: linear-gradient( 180deg, #FEE68A 0%, #FEF4DD 58.81%, #FFEEC7 100%), rgba(243,81,74,0.08);
  box-shadow: 0.02rem 0.02rem 0.02rem 0px rgba(128,103,207,0.6);
  border-radius: 0.2rem;
  line-height: 0.2rem;
}
.gate_sub {
  margin-top: 0.16rem;
  margin-bottom: 0.16rem;
  font-size: 0.15rem;
  color: rgba(255, 255, 255, 0.95);
  letter-spacing: 0.02rem;
}
.gate_contact {
  margin-top: -0.06rem;
  margin-bottom: -0.12rem;
  padding-left: 0.6rem;
  padding-right: 0.6rem;
}
.gate_contact .gate_contact_item {
  width: 0.1rem;
  height: 0.38rem;
  background: linear-gradient( 180deg, #FFEEC7 0%, #FFFFFF 41.19%, #FED6A5 100%);
  box-shadow: 0 0.01rem 0.04rem 0 rgba(0,0,0,0.2), inset -0.01rem -0.01rem 0.03rem 0 #FFB150;
  border-radius: 0.05rem;
  z-index: 1;
}
.gate_contact .gate_contact_item_line {
  width: 0.12rem;
  height: 0.12rem;
  background: #F97A06;
  box-shadow: inset 0 0.01rem 0.01rem 0 rgba(0,0,0,0.21);
  border-radius: 50%;
  position: absolute;
  bottom: -0.02rem;
}
.gate_contact .gate_contact_item_line.left {
  left: 0.59rem;
}
.gate_contact .gate_contact_item_line.right {
  right: 0.59rem;
}
.gate_card,
.gate_process {
  width: 100%;
  box-sizing: border-box;
  border-radius: 0.2rem;
  padding: 0.24rem 0.24rem 0.3rem;
  background: linear-gradient( 180deg, #F2E8FF 0%, rgba(255,255,255,0.5) 20%), #FFFFFF;
  border: 0.02rem solid #FFFFFF;
}
.gate_process {
  padding: 0.33rem 0 0;
}
.gate_process .gate_card_hd {
  padding: 0 0.24rem;
  margin-bottom: 0;
}
.gate_card {
  box-shadow: 0 0.08rem 0.2rem rgba(90, 60, 180, 0.12);
}
.gate_card_hd {
  display: flex;
  align-items: center;
  font-size: 0.16rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.18rem;
}
.gate_bar {
  width: 0.06rem;
  height: 0.19rem;
  margin-right: 0.08rem;
  border-radius: 0.3rem;
  background: linear-gradient(0deg, #7F60DF 0%, #BD89FF 100%);
}
.code_boxes {
  display: flex;
  justify-content: space-between;
  padding: 0 0.06rem;
}
.code_box {
  width: 0.6rem;
  height: 0.6rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #C7BAEC;
  border-radius: 0.12rem;
  background: #F8F3FF;
  text-align: center;
  font-size: 0.24rem;
  font-weight: 600;
  color: #292929;
  outline: none;
  caret-color: #7b5cff;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.code_box:focus {
  border-color: #8067CF;
}
.gate_tip {
  margin-top: 0.24rem;
  text-align: center;
  font-size: 0.15rem;
  color: #8067CF;
}
.gate_submit {
  margin-top: 0.1rem;
  height: 0.57rem;
  line-height: 0.57rem;
  font-size: 0.15rem;
  font-weight: 600;
}
.gate_submit.van-button--disabled {
  opacity: 0.7;
}
.gate_steps {
  display: block;
  width: 100%;
}
.gate_footer {
  margin-top: 0.28rem;
  font-size: 0.13rem;
  color: rgba(255, 255, 255, 0.5);
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/regionPasswordGateFromGroup.vue